module.exports = __webpack_public_path__ + "img/footer.19698fd0.jpg";